  let IS_PAGINATION = window.eventSettings?.enablePagination ?? true;
  let ALL_EVENTS = [];
  let CURRENT_STATUS = 'open_registration';
  // let CURRENT_GENDER = 'all';
  let CURRENT_REGION = 'all';
  let CURRENT_DATE_FROM = null;
  let CURRENT_DATE_TO = null;
  let CURRENT_ENVIRONMENT = 'all';
  let CURRENT_SURFACE = 'all';
  let CURRENT_SEARCH = '';
  let CURRENT_COUNTRY = 'all';
  let CURRENT_STATE = 'all';
  let CURRENT_PAGE = 1;
  let CLUB_ADDITIONAL = [17029,9,1762722];
  const PAGE_SIZE = 11;

  let CURRENT_CAMP_TYPE = 'all';
  let CURRENT_CAMP_DURATION = 'all';
  let CURRENT_AGE_GROUP = 'all';

  document.addEventListener('click', () => {
    document.querySelectorAll('.select-dropdown, .surface-dropdown').forEach((d) => d.classList.remove('show'));
  });

  document.querySelectorAll('.custom-select').forEach((select) => {
    const btn = select.querySelector('.select-btn');
    const dropdown = select.querySelector('.select-dropdown');

    btn.addEventListener('click', (e) => {
      e.stopPropagation();

      document.querySelector('.surface-dropdown')?.classList.remove('show');
      document.querySelectorAll('.select-dropdown').forEach((d) => {
        if (d !== dropdown) d.classList.remove('show');
      });

      dropdown.classList.toggle('show');
    });

    dropdown.querySelectorAll('.select-item').forEach((item) => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();

        dropdown.querySelectorAll('.select-item').forEach((i) => i.classList.remove('active'));

        item.classList.add('active');
        items.forEach(i => i.classList.remove('active'));

        updateSelectButtonText(btn, item.innerText);

        select.dataset.value = item.dataset.value;

        dropdown.classList.remove('show');
        updateActiveFilterCount();

      });
    });
  });

  /* =========================================================
   SURFACE FILTER
  ========================================================= */
  const surfaceBtn = document.querySelector('.surface-btn');
  if (surfaceBtn && !surfaceBtn.querySelector('svg')) {
    surfaceBtn.innerHTML = `
      <span class="surface-text">All | All</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M0.134474 4.15884C-0.0330075 4.33829 -0.0429962 4.60822 0.0986352 4.79832L0.158843 4.86553L7.65884 11.8655C7.82693 12.0224 8.07618 12.042 8.26457 11.9244L8.34116 11.8655L15.8412 4.86553C16.043 4.67711 16.0539 4.36072 15.8655 4.15884C15.698 3.9794 15.4294 3.95084 15.23 4.07904L15.1588 4.13447L7.999 10.815L0.841161 4.13447C0.661716 3.96699 0.391787 3.957 0.201687 4.09864L0.134474 4.15884Z" fill="black"/>
      </svg>
    `;
  }

  const surfaceDropdown = document.querySelector('.surface-dropdown');
  const outdoor = document.getElementById('outdoor');
  const indoor = document.getElementById('indoor');
  const envAll = document.getElementById('env_all');

  surfaceBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    document.querySelectorAll('.select-dropdown').forEach(d => d.classList.remove('show'));
    surfaceDropdown.classList.toggle('show');
  });

  surfaceDropdown.addEventListener('click', (e) => e.stopPropagation());

  function updateSurfaceButton() {
    let type = 'All';

    if (CURRENT_ENVIRONMENT === 'outdoor') type = 'Outdoor';
    if (CURRENT_ENVIRONMENT === 'indoor') type = 'Indoor';

    const surface =
      document.querySelector('.surface-item.active')?.innerText || 'All';

    const textEl = surfaceBtn.querySelector('.surface-text');
    if (textEl) {
      textEl.innerText = `${type} | ${surface}`;
    }
  }

  /* ===== ENVIRONMENT: Outdoor / Indoor ===== */
  [envAll, outdoor, indoor].forEach(cb => {
    cb.addEventListener('click', () => {

      // ===== ALL =====
      if (cb === envAll && envAll.checked) {
        outdoor.checked = false;
        indoor.checked = false;
        CURRENT_ENVIRONMENT = 'all';
      }

      // ===== OUTDOOR =====
      if (cb === outdoor && outdoor.checked) {
        envAll.checked = false;
        indoor.checked = false;
        CURRENT_ENVIRONMENT = 'outdoor';
      }

      // ===== INDOOR =====
      if (cb === indoor && indoor.checked) {
        envAll.checked = false;
        outdoor.checked = false;
        CURRENT_ENVIRONMENT = 'indoor';
      }

      // fallback: All
      if (!envAll.checked && !outdoor.checked && !indoor.checked) {
        envAll.checked = true;
        CURRENT_ENVIRONMENT = 'all';
      }

      updateSurfaceButton();
      applyFilters(true);
      surfaceDropdown.classList.remove('show');
    });
  });

  /* ===== SURFACE: Grass / Clay / Hardcourt ===== */
  document.querySelectorAll('.surface-item').forEach(item => {
    item.addEventListener('click', () => {
      document.querySelectorAll('.surface-item')
        .forEach(i => i.classList.remove('active'));

      item.classList.add('active');
      CURRENT_SURFACE = item.dataset.value;

      updateSurfaceButton();
      surfaceDropdown.classList.remove('show');
      applyFilters(true);
    });
  });

  updateSurfaceButton();

  /* =========================================================
   DATE PICKER (Flatpickr range)
   ========================================================= */
  const clearBtn = document.getElementById('clear-date');
  clearBtn.style.display = 'none';

  const datePicker = flatpickr('#date_range', {
    mode: 'range',
    dateFormat: 'm/d/Y',

    onChange(selectedDates) {
      if (selectedDates.length !== 2) {
        clearBtn.style.display = 'none';
        return;
      }

      clearBtn.style.display = 'block';

      const from = formatDateMMDDYYYY(selectedDates[0]);
      const to   = formatDateMMDDYYYY(selectedDates[1]);

      CURRENT_DATE_FROM = from;
      CURRENT_DATE_TO   = to;

      fetchInitialEvents(from, to);
      scrollToTop();
    }
  });

  clearBtn.addEventListener('click', async () => {
    datePicker.clear();

    clearBtn.style.display = 'none';

    CURRENT_DATE_FROM = null;
    CURRENT_DATE_TO = null;

    await fetchInitialEvents();

    applyFilters(true);
  });

  /* =========================================================
   TABLE SORTING
  ========================================================= */
  const table = document.querySelector('.event-table tbody');
  let nameAsc = true;
  let dateAsc = true;
  let countryAsc = true;
  let cityAsc = true;
  let prizeAsc = true;
  let surfaceAsc = true;
  let statusAsc = true;
  /* sort name */
  document.getElementById('sortName').addEventListener('click', () => {
    const rows = [...table.rows];

    rows.sort((a, b) => {
      const A = a.cells[0].querySelector('.event-title')?.innerText.toLowerCase() || '';
      const B = b.cells[0].querySelector('.event-title')?.innerText.toLowerCase() || '';
      return nameAsc ? A.localeCompare(B) : B.localeCompare(A);
    });

    nameAsc = !nameAsc;
    table.append(...rows);
  });

  function softDate(){
    const rows = [...table.rows];

  rows.sort((a, b) => {
    const A = a.cells[1]?.dataset?.start;
    const B = b.cells[1]?.dataset?.start;

    if (!A) return 1;
    if (!B) return -1;

    return dateAsc
      ? new Date(A).getTime() - new Date(B).getTime()
      : new Date(B).getTime() - new Date(A).getTime();
  });

  dateAsc = !dateAsc;
  table.append(...rows);
  }
  /* sort date */
  document.getElementById('sortDate')?.addEventListener('click', () => {
  softDate();
});


  /* sort city */
  document.getElementById('sortCity').addEventListener('click', () => {
    const rows = [...table.rows];

    rows.sort((a, b) => {
      const A = a.cells[3].innerText.toLowerCase();
      const B = b.cells[3].innerText.toLowerCase();
      return cityAsc ? A.localeCompare(B) : B.localeCompare(A);
    });

    cityAsc = !cityAsc;
    table.append(...rows);
  });

  /* sort prize */
  // document.getElementById('sortPrize').addEventListener('click', () => {
  //   const rows = [...table.rows];

  //   rows.sort((a, b) => {
  //     const A = parseInt(a.cells[4].innerText.replace(/\D/g, ''));
  //     const B = parseInt(b.cells[4].innerText.replace(/\D/g, ''));
  //     return prizeAsc ? A - B : B - A;
  //   });

  //   prizeAsc = !prizeAsc;
  //   table.append(...rows);
  // });

  /* sort Surface */
  document.getElementById('sortSurface').addEventListener('click', () => {
    const rows = [...table.rows];

    rows.sort((a, b) => {
      const A = a.cells[5].dataset.surface.toLowerCase();
      const B = b.cells[5].dataset.surface.toLowerCase();
      return surfaceAsc ? A.localeCompare(B) : B.localeCompare(A);
    });

    surfaceAsc = !surfaceAsc;
    table.append(...rows);
  });

  /* sort status */
  document.getElementById('sortStatus').addEventListener('click', () => {
    const rows = [...table.rows];

    rows.sort((a, b) => {
      const A = a.cells[6].innerText.trim().toLowerCase();
      const B = b.cells[6].innerText.trim().toLowerCase();

      return statusAsc
        ? A.localeCompare(B)
        : B.localeCompare(A);
    });

    statusAsc = !statusAsc;
    table.append(...rows);
  });

  // JS mobile
  // const toggleBtn = document.getElementById('popup-filter');
  // const filtersWrapper = document.getElementById('filtersWrapper');
  // const toggleText = document.getElementById('toggleText');
  const filterCountEl = document.getElementById('activeFilterCount');

  // /* ===== Show / Hide filters (mobile) ===== */
  //   toggleBtn.addEventListener('click', () => {
  //     filtersWrapper.classList.toggle('show');

  //     const isShow = filtersWrapper.classList.contains('show');

  //     toggleText.innerText = isShow ? 'Hide' : 'Show';
  //     toggleBtn.classList.toggle('open', isShow);
  //   });
  

  const popupBtn = document.getElementById('popup-modal');
const popup = document.getElementById('filterPopup');
const closePopup = document.getElementById('closeFilterPopup');
const viewBtn = document.getElementById('viewResultsBtn');

const filtersWrapper = document.getElementById('filtersWrapper');
const popupFilters = document.getElementById('popupFilters');

const originalParent = filtersWrapper.parentNode;
const originalNext = filtersWrapper.nextSibling;

popupBtn?.addEventListener('click', () => {

  popup.classList.add('show');
  document.body.style.overflow = 'hidden';

  popupFilters.appendChild(filtersWrapper);

});

function closePopupFilter(){

  popup.classList.remove('show');
  document.body.style.overflow = '';

  if(originalNext){
    originalParent.insertBefore(filtersWrapper, originalNext);
  }else{
    originalParent.appendChild(filtersWrapper);
  }

}

closePopup?.addEventListener('click', closePopupFilter);

viewBtn?.addEventListener('click', closePopupFilter);

  /* ===== Count active filters ===== */
  function updateActiveFilterCount() {
    let count = 0;

    /* custom selects */
    document.querySelectorAll('#filtersWrapper .custom-select').forEach((select) => {
      if (window.getComputedStyle(select).display === 'none') return;
      const value = select.dataset.value || select.querySelector('.select-btn')?.innerText;
      if (value && value.toLowerCase() !== 'all' && value.toLowerCase().trim() !== 'all') {
        count++;
      }
    });

    /* date */
    const dateVal = document.getElementById('date_range')?.value;
    if (dateVal) count++;

    /* surface */
    const surfaceVal = document.querySelector('#filtersWrapper .surface-btn')?.innerText;
    if (surfaceVal && !surfaceVal.toLowerCase().includes('all')) {
      count++;
    }

    filterCountEl.innerText = count;
    document.getElementById('popupActiveFilterCount').innerText = count;
    
  }

  /* ===== Bind updates ===== */
  document.addEventListener('click', updateActiveFilterCount);
  document.addEventListener('change', updateActiveFilterCount);

  /* Initial */
  // updateActiveFilterCount();

  /* =========================================================
   INITIAL LOAD → Fetch all events data
  ========================================================= */

  document.addEventListener('DOMContentLoaded', () => {
    fetchInitialEvents();
  });

  /* =========================================================
    FETCH EVENTS FROM UTR API
  ========================================================= */
//   async function fetchClubData(from, to) {
//     const start = from || getFirstDayOfCurrentMonth();
//     const end   = to   || getEndOfNextYear();

//     const API_URL =
//       `https://api.utrsports.net/v2/search/events?top=40&searchOrigin=searchPage&showTennisContent=true&showPickleballContent=true&tours=HotelPlanner+UTR+Shootout+Series&eventState=open_registration&utrMin=1&utrMax=16&utrType=verified&utrTeamType=singles`;

//     const res = await fetch(API_URL);
//     const data = await res.json();
//     debugger;
    
//     return data.hits.map(({ id, source: src }) => (
//       const clubName = src.club?.name || '';
//       {
//         id,
//         name: src.name,
//         start: src.eventSchedule?.eventStartUtc || null,
//         end: src.eventSchedule?.eventEndUtc || null,
//         city: src.eventLocations?.[0]?.cityName,
//         stateName: src.eventLocations?.[0]?.stateName,
//         prize: src.prizeMoney,
//         surface: src.eventDivisions?.[0]?.surfaces?.[0]?.value,
//         environment: src.eventDivisions?.[0]?.environments?.[0]?.value,
//         status: src.eventState?.value,
//         gender: src.gender,
//         region: normalizeRegion(clubName),
//         countryName: src.eventLocations?.[0]?.countryName,
//         countryCode2: src.eventLocations?.[0]?.countryCode2?.toUpperCase(),
//         stateName: src.eventLocations?.[0]?.stateName,
//     }));
// }

  async function fetchInitialEvents(from, to) {

    const start = from || getFirstDayOfCurrentMonth();
    const end   = to   || getEndOfNextYear();
    const API_URL =
  'https://api.utrsports.net/v2/search/events?' +
  'tours=College Camps for Juniors' +
  //'&eventState=open_registration' +
  '&top=250' +
  '&skip=0' +
  `&range=eventSchedule.eventStartUtc>=${start}` +
  `&range=eventSchedule.eventStartUtc<=${end}` +
  '&sort=eventSchedule.eventStartUtc:asc';

    //console.log('FETCH:', API_URL);

    let res = await fetch(API_URL);
    let data = await res.json();

    if (!Array.isArray(data.hits)) {
      ALL_EVENTS = [];
      return;
    }

    ALL_EVENTS = data.hits.map(({ id, source: src }) => {
      const clubName = src.club?.name || '';
      if(CURRENT_CAMP_TYPE !== 'all'){
        if(!src.details || !isHaveText(src.details,CURRENT_CAMP_TYPE)) return false;
      }
      if (CURRENT_CAMP_DURATION !== 'all') {
      const numberOfDays = getDaysBetween(
        src.eventSchedule?.eventStartUtc, 
        src.eventSchedule?.eventEndUtc
      );

      if (CURRENT_CAMP_DURATION === '2' && numberOfDays > 2) return false;
      if (CURRENT_CAMP_DURATION === '3' && numberOfDays <= 2) return false;
    }
      if(CURRENT_AGE_GROUP !== 'all'){
        if(!src.details || !isHaveText(src.details,CURRENT_AGE_GROUP)) return false;
      }
    
      let currentAgeGroup = detectAgeGroup(src.details);
      let currentCampType = detectCampType(src.eventDivisions);
      let currentCampDuration = "_";
    
      //debugger;

      const currentNumberOfDay = getDaysBetween(src.eventSchedule?.eventStartUtc,src.eventSchedule?.eventEndUtc);
      if (currentNumberOfDay <= 2) {
        currentCampDuration = "2 days or fewer";
      } else {
        currentCampDuration = "3 days or more";
      }
      
      return {
        id,
        name: src.name,
        start: src.eventSchedule?.eventStartUtc || null,
        end: src.eventSchedule?.eventEndUtc || null,
        city: src.eventLocations?.[0]?.cityName,
        stateName: src.eventLocations?.[0]?.stateName,
        prize: src.prizeMoney,
        surface: src.eventDivisions?.[0]?.surfaces?.[0]?.value,
        environment: src.eventDivisions?.[0]?.environments?.[0]?.value,
        status: src.eventState?.value,
        gender: src.gender,
        details: src.details,
        region: normalizeRegion(clubName),
        countryName: src.eventLocations?.[0]?.countryName,
        countryCode2: src.eventLocations?.[0]?.countryCode2?.toUpperCase(),
        stateName: src.eventLocations?.[0]?.stateName,
        ageGroup: currentAgeGroup,
        campType: currentCampType,
        campDuration: currentCampDuration,
        eventDivisions: src.eventDivisions || []
      };
    });
  
    // ALL_EVENTS = await fetchClubData(from, to);
    //console.log(ALL_EVENTS);
    // buildCountryFilter(ALL_EVENTS);
    buildStateFilter(ALL_EVENTS);
    applyFilters(true);
    // softDate();
  }

  function detectAgeGroup(details){
    if(!details) return "_";

    const text = details
        .replace(/–|—/g,'-')
        .replace(/\s+/g,' ');

    const match = text.match(
        /\bage?s?\s*(\d{1,2})\s*-\s*(\d{1,2})\b/i
    );

    if(match){
        return `${match[1]} - ${match[2]}`;
    }

    return "_";
  }

  function detectCampType(eventDivisions) {
    if (!Array.isArray(eventDivisions) || !eventDivisions.length) {
      return "_";
    }

    const rawNames = eventDivisions
      .map(x => x.name || '')
      .filter(Boolean);

    const normalized = rawNames
      .join(' ')
      .toLowerCase()
      .replace(/-/g,' ');

    const hasFullDay = normalized.includes('full day');
    const hasHalfDay = normalized.includes('half day');
    const hasOvernight = normalized.includes('overnight');

    if (hasFullDay && hasHalfDay) return 'Full day / Half day';
    if (hasFullDay) return 'Full day';
    if (hasHalfDay) return 'Half day';
    if (hasOvernight) return 'Overnight';

    const hasDayPackages =
        normalized.includes('1 day') ||
        normalized.includes('2 day') ||
        normalized.includes('3 day');

    if (hasDayPackages){
      return 'Full day';
    }

    if (
        normalized.includes('junior tour') ||
        normalized.includes('intensive tennis') ||
        normalized.includes('surf and tennis') ||
        normalized.includes('golf and tennis') ||
        normalized.includes('two day registration') ||
        normalized.includes('one day registration') ||
        normalized.includes('registration for 1 camper') || 
        normalized.includes('registration for camper')
    ){
        return 'Full day';
    }

    return "_";
  }

  const searchForm = document.querySelector('.search-form');
  const searchInput = document.querySelector('.search-input');

  searchForm.addEventListener('submit', (e) => {
    e.preventDefault();

    CURRENT_SEARCH = searchInput.value.trim().toLowerCase();
    applyFilters(true);
  });

  searchInput.addEventListener('input', () => {
    CURRENT_SEARCH = searchInput.value.trim().toLowerCase();
    applyFilters(true);
  });

  function formatEventDateRange(startUtc, endUtc) {
    if (!startUtc || !endUtc) return '-';
    const start = new Date(startUtc);
    const end = new Date(endUtc);
    const opts = { month: 'short', day: 'numeric' };
    const s = start.toLocaleDateString('en-US', opts);
    const e = end.toLocaleDateString('en-US', opts);
    const sy = String(start.getFullYear()).slice(-2);
    const ey = String(end.getFullYear()).slice(-2);
    return `${s}, '${sy} - ${e}, '${ey}`;
  }

  function formatEventDateRangeM(startDate, endDate) {
    if (!startDate || !endDate) return "-";

    const start = new Date(startDate);
    const end = new Date(endDate);
    if (end.getHours() <= 4 && end.getMinutes() === 0) {
      end.setDate(end.getDate() - 1);
    }

    const startYear = start.getFullYear();
    const endYear = end.getFullYear();

    const formatWithoutYear = { month: "short", day: "numeric" };

    const formatWithApostropheYear = (date) => {
      const monthDay = date.toLocaleDateString("en-US", formatWithoutYear);
      const shortYear = String(date.getFullYear()).slice(-2);
      return `${monthDay}, '${shortYear}`;
    };

    if (startYear === endYear) {
      return `${start.toLocaleDateString("en-US", formatWithoutYear)} – ${formatWithApostropheYear(end)}`;
    }

    return `${formatWithApostropheYear(start)} – ${formatWithApostropheYear(end)}`;
  }

  function getFirstDayOfCurrentMonth() {
    const d = new Date();
    d.setDate(1);
    return formatDateMMDDYYYY(d);
  }

  function getEndOfNextYear() {
    const now = new Date();
    const nextYear = now.getFullYear() + 1;

    const d = new Date(nextYear, 11, 31);
    return formatDateMMDDYYYY(d);
  }

  function formatDateMMDDYYYY(date) {
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const y = date.getFullYear();
    return `${m}/${d}/${y}`;
  }

function isHaveText(bigContent, text) {
  if (!bigContent || !text) return false;

  const content = bigContent.toLowerCase();
  const keyword = text.toLowerCase();

  return content.includes(keyword);
}
function getDaysBetween(from, to) {
  if (!from || !to) return 0;

  const fromDate = new Date(from);
  const toDate   = new Date(to);

  if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
    //console.warn('Invalid date:', from, to);
    return 0;
  }

  const startUTC = Date.UTC(
    fromDate.getUTCFullYear(),
    fromDate.getUTCMonth(),
    fromDate.getUTCDate()
  );

  const endUTC = Date.UTC(
    toDate.getUTCFullYear(),
    toDate.getUTCMonth(),
    toDate.getUTCDate()
  );

  const diffTime = endUTC - startUTC;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1; 

  return Math.max(1, diffDays);
}

  function applyFilters(resetPage = false) {

    if (resetPage) CURRENT_PAGE = 1;

    const tbody = document.getElementById('eventTableBody');
    const cardList = document.getElementById('eventCardList');

    tbody.innerHTML = '';
    cardList.innerHTML = '';

    const today = new Date();
    today.setHours(0,0,0,0);

    const from = CURRENT_DATE_FROM ? new Date(CURRENT_DATE_FROM + 'T00:00:00') : null;
    const to   = CURRENT_DATE_TO   ? new Date(CURRENT_DATE_TO   + 'T23:59:59') : null;


    let filtered = ALL_EVENTS.filter(e => {
      if (!e.start) return false;

      const startDate = new Date(e.start);
      const endDate   = e.end ? new Date(e.end) : null;

      /* ================= STATUS ================= */
      
      if (CURRENT_STATUS === 'in_progress') {
        if (e.status !== 'in_progress') return false;
      }
      else if (CURRENT_STATUS !== 'all') {
        if (e.status !== CURRENT_STATUS) return false;
      }

      /* ================= DATE FILTER ================= */

      if (from && to) {
        if (startDate < from || startDate > to) return false;
      } else {
        if (CURRENT_STATUS === 'all') {
          // if (startDate < today) return false;
        }

        if (CURRENT_STATUS === 'in_progress') {
          
        }

        if (CURRENT_STATUS === 'completed') {
          if (e.status !== 'completed') return false;
        }
      }

      /* ================= OTHER FILTERS ================= */
      // if (CURRENT_GENDER !== 'all' && e.gender !== 'Co-ed' && e.gender !== CURRENT_GENDER) return false;
      if (CURRENT_REGION !== 'all' && e.region !== CURRENT_REGION) return false;

      if (CURRENT_ENVIRONMENT !== 'all') {
        if (!e.environment) return false;
        if (e.environment.toLowerCase() !== CURRENT_ENVIRONMENT) return false;
      }

      if (CURRENT_SURFACE !== 'all') {
        if (!e.surface) return false;
        if (!e.surface.toLowerCase().includes(CURRENT_SURFACE)) return false;
      }

      if (CURRENT_SEARCH) {

        const haystack = [
          e.name,
          e.stateName,
          e.city,
          e.countryName,
          e.campType,
          e.campDuration,
          e.status,
          e.surface,
          e.environment,
          e.gender,
          e.region,
          e.details,
          formatEventDateRangeM(e.start,e.end)
        ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

        const terms = CURRENT_SEARCH
          .split(/\s+/)
          .filter(Boolean);

        const matched = terms.every(term =>
          haystack.includes(term)
        );

        if (!matched) return false;
      }

      if (CURRENT_COUNTRY !== 'all') {
        if (!e.countryName || e.countryName !== CURRENT_COUNTRY) return false;
      }

      if (CURRENT_STATE !== 'all') {
        if (!e.stateName || e.stateName !== CURRENT_STATE) return false;
      }

      if (CURRENT_CAMP_TYPE !== 'all') {
        if (CURRENT_CAMP_TYPE === 'Full day') {
          if (
            e.campType !== 'Full day' &&
            e.campType !== 'Full day / Half day'
          ) return false;
        }

        if (CURRENT_CAMP_TYPE === 'Half day') {
          if (
            e.campType !== 'Half day' &&
            e.campType !== 'Full day / Half day'
          ) return false;
        }

        if (
          CURRENT_CAMP_TYPE === 'Overnight' &&
          e.campType !== 'Overnight'
        ){
          return false;
        }
      }
      if(CURRENT_CAMP_DURATION !== 'all'){
        const numberofday = getDaysBetween(startDate,endDate);
        if (CURRENT_CAMP_DURATION == 2 && numberofday > 2) return false;
        if (CURRENT_CAMP_DURATION == 3 && numberofday <= 2) return false;
      }
      // if(CURRENT_AGE_GROUP !== 'all'){
      //   if(!e.details || !isHaveText(e.details,CURRENT_AGE_GROUP)) return false;
      // }
      return true;
    });

    const total = filtered.length;

    if (!total) {
      tbody.innerHTML = `<tr><td colspan="7">No events</td></tr>`;
      cardList.innerHTML = `<div class="no-events">No events</div>`;
      updateResultCount(0);
      renderPagination(0);
      return;
    }

    updateResultCount(total);
    document.getElementById('popupResultCount').innerText =
    `${total} Results`;

    if (IS_PAGINATION) {
      const startIndex = (CURRENT_PAGE - 1) * PAGE_SIZE;
      const endIndex = startIndex + PAGE_SIZE;
      const paginated = filtered.slice(startIndex, endIndex);
      tbody.innerHTML = paginated.map(renderEventRow).join('');
      cardList.innerHTML = paginated.map(renderEventCard).join('');
      renderPagination(total);

    } else {
      tbody.innerHTML = filtered.map(renderEventRow).join('');
      cardList.innerHTML = filtered.map(renderEventCard).join('');
      renderPagination(0);
    }
  }
  function scrollToTop(){
    window.scrollTo(0, $('.ptt-calendar-table').offset().top);
    const tableTop = $('.ptt-calendar-table').offset().top - 100;
     $('html, body').animate({ scrollTop: tableTop }, 'fast');
  }

  document
  .querySelectorAll('.custom-select[data-name="status"] .select-item')
  .forEach((item) => {
    item.addEventListener('click', function () {
      CURRENT_STATUS = this.dataset.value;
      updateSelectUI(this);
      applyFilters(true);
      scrollToTop();
    });
  });

  // document
  // .querySelectorAll('.custom-select[data-name="gender"] .select-item')
  // .forEach((item) => {
  //   item.addEventListener('click', function () {
  //     CURRENT_GENDER = this.dataset.value;
  //     updateSelectUI(this);
  //     applyFilters(true);
  //     scrollToTop();
  //   });
  // });

  document
  .querySelectorAll('.custom-select[data-name="region"] .select-item')
  .forEach((item) => {
    item.addEventListener('click', function () {

      CURRENT_REGION = this.dataset.value;
      updateSelectUI(this);

      /* ===== RESET COUNTRY WHEN REGION CHANGES ===== */
      CURRENT_COUNTRY = 'all';

      const countrySelect = document.querySelector('.custom-select[data-name="country"]');
      if (countrySelect) {
        countrySelect.dataset.value = 'all';
      }

      /* ===== REBUILD COUNTRY LIST BASED ON REGION ===== */
      buildCountryFilterByRegion();

      applyFilters(true);
    });
  });

  document
  .querySelectorAll('.custom-select[data-name="country"] .select-item')
  .forEach((item) => {
    item.addEventListener('click', function () {

      CURRENT_COUNTRY = this.dataset.value;
      updateSelectUI(this);

      /* ===== RESET STATE WHEN REGION CHANGES ===== */
      CURRENT_STATE = 'all';

      const stateSelect = document.querySelector('.custom-select[data-name="state"]');
      if (stateSelect) {
        countrySelect.dataset.value = 'all';
      }

      /* ===== REBUILD COUNTRY LIST BASED ON REGION ===== */
      buildCountryFilterByRegion();
      buildStateFilterByCountry();

      applyFilters(true);
    });
  });


  /*========= NEW ============= */
//  document
//   .querySelectorAll('.custom-select[data-name="age-group"] .select-item')
//   .forEach((item) => {
//     item.addEventListener('click', function () {
//       CURRENT_AGE_GROUP = this.dataset.value;
//       updateSelectUI(this);
//       applyFilters(true);
//       scrollToTop();
//     });
//   });
  document
  .querySelectorAll('.custom-select[data-name="camp-type"] .select-item')
  .forEach((item) => {
    item.addEventListener('click', function () {
      CURRENT_CAMP_TYPE = this.dataset.value;
      updateSelectUI(this);
      applyFilters(true);
      scrollToTop();
    });
  });
  document
  .querySelectorAll('.custom-select[data-name="camp-duration"] .select-item')
  .forEach((item) => {
    item.addEventListener('click', function () {
      CURRENT_CAMP_DURATION = this.dataset.value;
      updateSelectUI(this);
      applyFilters(true);
      scrollToTop();
    });
  });

  /* ======== State Area ========== */

document
  .querySelector('.custom-select[data-name="state"] .select-dropdown')?.addEventListener('click', function (e) {
    const item = e.target.closest('.select-item');
    if (!item) return;

    this.querySelectorAll('.select-item')
      .forEach(i => i.classList.remove('active'));

    item.classList.add('active');

    CURRENT_STATE = item.dataset.value;

    const btn = document.querySelector('.custom-select[data-name="state"] .select-btn');
    updateSelectButtonText(btn, item.innerText);

    if (CURRENT_STATE === 'all') {
      CURRENT_COUNTRY = 'all';
    } else {
      const foundEvent = ALL_EVENTS.find(e => e.stateName === CURRENT_STATE);
      if (foundEvent) {
        CURRENT_COUNTRY = foundEvent.countryName;
      }
    }
    updateCountrySelectUI();
    buildStateFilterByCountry();

    applyFilters(true);
      const stateSelect = document.querySelector('.custom-select[data-name="state"]');
      if (stateSelect) {
        stateSelect.dataset.value = CURRENT_STATE;
      }
      scrollToTop();
  });


  document
  .querySelector('.custom-select[data-name="state"] .select-dropdown')
  ?.addEventListener('wheel', e => {
    e.stopPropagation();
  });

  /* ======== END State Area ========== */



  document
  .querySelector('.custom-select[data-name="country"] .select-dropdown')?.addEventListener('click', function (e) {
    const item = e.target.closest('.select-item');
    if (!item) return;

    this.querySelectorAll('.select-item')
      .forEach(i => i.classList.remove('active'));

    item.classList.add('active');

    CURRENT_COUNTRY = item.dataset.value;

    const btn = document.querySelector('.custom-select[data-name="country"] .select-btn');
    updateSelectButtonText(btn, item.innerText);

    if (CURRENT_COUNTRY === 'all') {
      CURRENT_REGION = 'all';
    } else {
      const foundEvent = ALL_EVENTS.find(e => e.countryName === CURRENT_COUNTRY);
      if (foundEvent) {
        CURRENT_REGION = foundEvent.region;
      }
    }
    updateRegionSelectUI();
    buildCountryFilterByRegion();
    buildStateFilterByCountry();

    applyFilters(true);
      const countrySelect = document.querySelector('.custom-select[data-name="country"]');
      if (countrySelect) {
        countrySelect.dataset.value = CURRENT_COUNTRY;
      }
      scrollToTop();
  });

  document
  .querySelector('.custom-select[data-name="country"] .select-dropdown')
  ?.addEventListener('wheel', e => {
    e.stopPropagation();
  });

  function updateSelectUI(item) {
  const select = item.closest('.custom-select');
  const btn = select.querySelector('.select-btn');

  select.querySelectorAll('.select-item')
    .forEach(i => i.classList.remove('active'));

  item.classList.add('active');
  updateSelectButtonText(btn, item.innerText);
}

  /* =========================================================
    FORMAT HELPERS
  ========================================================= */

  function formatPrize(prize) {
    return prize ? `$${prize.toLocaleString()}` : '-';
  }

  function formatCity(city, hasComma = false) {
    if (!city) return '';
    const parts = city.split(',');
    if(parts.length > 1){
      return `
        ${parts[0].trim()}${hasComma?',':''}</br>
        ${parts[1]?.trim() || ''}
      `;
    }else{
      return `
        ${parts[0].trim()}${hasComma?',':''}</br>
      `;
    }
    
  }

  function formatCityOnly(city) {
    if (!city) return '';
    return city.replace(/,\s*$/, '').trim();
  }

  function formatSurface(env, surface) {
    if (!env && !surface) return '-';

    let formattedSurface = surface;

    if (surface && surface.toLowerCase() === 'hardcourt') {
      formattedSurface = 'Hard';
    }

    if (env && formattedSurface) return `${env} | ${formattedSurface}`;
    return env || formattedSurface;
  }


  function normalizeRegion(clubName = '') {
    if (!clubName.includes('-')) return 'unknown';

    const raw = clubName.split('-').pop().trim().toLowerCase();

    if (raw.includes('asia')) return 'asia';
    if (raw.includes('europe')) return 'europe';
    if (raw.includes('america')) return 'americas';

    return 'unknown';
  }

  function renderRegionLabel(region) {
    if (region === 'asia') return 'Asia & Pacific';
    if (region === 'europe') return 'Europe';
    if (region === 'americas') return 'Americas';
    return '-';
  }

  function renderStatusBadge(statusValue) {
    if (!statusValue) return '-';

    const STATUS_MAP = {
      pre_registration: {
        text: 'Register',
        class: 'badge-open',
      },
      open_registration: {
        text: 'Register',
        class: 'badge-open',
      },
      registration_closed: {
        text: 'Upcoming',
        class: 'badge-upcoming',
      },
      in_progress: {
        text: 'Live',
        class: 'badge-live',
      },
      completed: {
        text: 'Complete',
        class: 'badge-complete',
      },
    };

    const status = STATUS_MAP[statusValue];

    if (!status) {
      return `<span class="badge badge-default">${statusValue}</span>`;
    }

    return `<span class="badge ${status.class}">${status.text}</span>`;
  }

  function buildStateFilter(events){
    const select = document.querySelector('.custom-select[data-name="state"]');
    const dropdown = select.querySelector('.select-dropdown');
    const btn = select.querySelector('.select-btn');

    if (!dropdown || !btn) return;

    dropdown.innerHTML = '';

    // ===== All =====
    const allItem = document.createElement('div');
    allItem.className = 'select-item active';
    allItem.dataset.value = 'all';
    allItem.innerText = 'All';
    dropdown.appendChild(allItem);

    // ===== Countries =====
    const countries = [...new Set(
      events.map(e => e.stateName).filter(Boolean)
    )].sort((a, b) => a.localeCompare(b));

    countries.forEach(state => {
      const item = document.createElement('div');
      item.className = 'select-item';
      item.dataset.value = state;
      item.innerText = state;
      dropdown.appendChild(item);
    });

    // ===== CLICK HANDLER =====
    dropdown.querySelectorAll('.select-item').forEach(item => {
      item.addEventListener('click', () => {
        dropdown.querySelectorAll('.select-item')
          .forEach(i => i.classList.remove('active'));

        item.classList.add('active');

        CURRENT_COUNTRY = item.dataset.value;
        updateSelectButtonText(btn, item.innerText);

        applyFilters(true);
      });
    });
  }

  function buildCountryFilter(events) {
    const select = document.querySelector('.custom-select[data-name="country"]');
    const dropdown = select.querySelector('.select-dropdown');
    const btn = select.querySelector('.select-btn');

    if (!dropdown || !btn) return;

    dropdown.innerHTML = '';

    // ===== All =====
    const allItem = document.createElement('div');
    allItem.className = 'select-item active';
    allItem.dataset.value = 'all';
    allItem.innerText = 'All';
    dropdown.appendChild(allItem);

    // ===== Countries =====
    const countries = [...new Set(
      events.map(e => e.countryName).filter(Boolean)
    )].sort((a, b) => a.localeCompare(b));

    countries.forEach(country => {
      const item = document.createElement('div');
      item.className = 'select-item';
      item.dataset.value = country;
      item.innerText = country;
      dropdown.appendChild(item);
    });

    // ===== CLICK HANDLER =====
    dropdown.querySelectorAll('.select-item').forEach(item => {
      item.addEventListener('click', () => {
        dropdown.querySelectorAll('.select-item')
          .forEach(i => i.classList.remove('active'));

        item.classList.add('active');

        CURRENT_COUNTRY = item.dataset.value;
        updateSelectButtonText(btn, item.innerText);

        applyFilters(true);
      });
    });
  }

  function updateRegionSelectUI() {
    const select = document.querySelector('.custom-select[data-name="region"]');
    if (!select) return;

    const btn = select.querySelector('.select-btn');
    const items = select.querySelectorAll('.select-item');

    items.forEach(i => {
      i.classList.remove('active');

      if (i.dataset.value === CURRENT_REGION) {
        i.classList.add('active');
        updateSelectButtonText(btn, i.innerText);
      }
    });
  }

  function updateCountrySelectUI() {
    const select = document.querySelector('.custom-select[data-name="country"]');
    if (!select) return;

    const btn = select.querySelector('.select-btn');
    const items = select.querySelectorAll('.select-item');

    items.forEach(i => {
      i.classList.remove('active');

      if (i.dataset.value === CURRENT_COUNTRY) {
        i.classList.add('active');
        updateSelectButtonText(btn, i.innerText);
      }
    });
  }


  function buildStateFilterByCountry() {
    const select = document.querySelector('.custom-select[data-name="state"]');
    if (!select) return;

    const dropdown = select.querySelector('.select-dropdown');
    const btn = select.querySelector('.select-btn');

    dropdown.innerHTML = '';
    const countryEvents =
      CURRENT_COUNTRY === 'all'
        ? ALL_EVENTS
        : ALL_EVENTS.filter(e => e.countryName === CURRENT_COUNTRY);

        
    const states = [...new Set(
      countryEvents.map(e => e.stateName).filter(Boolean)
    )].sort((a, b) => a.localeCompare(b));

    // ===== All option =====
    const allItem = document.createElement('div');
    allItem.className = 'select-item';
    allItem.dataset.value = 'all';
    allItem.innerText = 'All';
    dropdown.appendChild(allItem);

    // ===== States =====
    states.forEach(country => {
      const item = document.createElement('div');
      item.className = 'select-item';
      item.dataset.value = country;
      item.innerText = country;
      dropdown.appendChild(item);
    });

    // ===== Restore selected state =====
    let stateStillValid = states.includes(CURRENT_STATE);

    if (!stateStillValid) {
      CURRENT_STATE = 'all';
    }

    dropdown.querySelectorAll('.select-item').forEach(item => {
      if (item.dataset.value === CURRENT_STATE) {
        item.classList.add('active');
        updateSelectButtonText(btn, item.innerText);
      }

      item.addEventListener('click', () => {
        dropdown.querySelectorAll('.select-item')
          .forEach(i => i.classList.remove('active'));

        item.classList.add('active');
        CURRENT_STATE = item.dataset.value;
        updateSelectButtonText(btn, item.innerText);

        applyFilters(true);
      });
    });

    if (!stateStillValid) {
      updateSelectButtonText(btn, 'All');
      dropdown.querySelector('.select-item[data-value="all"]')
        ?.classList.add('active');
    }
  }

  function buildCountryFilterByRegion() {
    const select = document.querySelector('.custom-select[data-name="country"]');
    if (!select) return;

    const dropdown = select.querySelector('.select-dropdown');
    const btn = select.querySelector('.select-btn');

    dropdown.innerHTML = '';

    const regionEvents =
      CURRENT_REGION === 'all'
        ? ALL_EVENTS
        : ALL_EVENTS.filter(e => e.region === CURRENT_REGION);

    const countries = [...new Set(
      regionEvents.map(e => e.countryName).filter(Boolean)
    )].sort((a, b) => a.localeCompare(b));

    // ===== All option =====
    const allItem = document.createElement('div');
    allItem.className = 'select-item';
    allItem.dataset.value = 'all';
    allItem.innerText = 'All';
    dropdown.appendChild(allItem);

    // ===== Countries =====
    countries.forEach(country => {
      const item = document.createElement('div');
      item.className = 'select-item';
      item.dataset.value = country;
      item.innerText = country;
      dropdown.appendChild(item);
    });

    // ===== Restore selected country =====
    let countryStillValid = countries.includes(CURRENT_COUNTRY);

    if (!countryStillValid) {
      CURRENT_COUNTRY = 'all';
    }

    dropdown.querySelectorAll('.select-item').forEach(item => {
      if (item.dataset.value === CURRENT_COUNTRY) {
        item.classList.add('active');
        updateSelectButtonText(btn, item.innerText);
      }

      item.addEventListener('click', () => {
        dropdown.querySelectorAll('.select-item')
          .forEach(i => i.classList.remove('active'));

        item.classList.add('active');
        CURRENT_COUNTRY = item.dataset.value;
        updateSelectButtonText(btn, item.innerText);

        applyFilters(true);
      });
    });

    if (!countryStillValid) {
      updateSelectButtonText(btn, 'All');
      dropdown.querySelector('.select-item[data-value="all"]')
        ?.classList.add('active');
    }
  }

  function updateSelectButtonText(btn, text) {
    if (!btn) return;

    // Nếu node đầu tiên là text
    if (btn.firstChild && btn.firstChild.nodeType === Node.TEXT_NODE) {
      btn.firstChild.nodeValue = text + ' ';
    } else {
      btn.insertBefore(document.createTextNode(text + ' '), btn.firstChild);
    }
  }


  function updateResultCount(count) {
    const resultCount = document.getElementById('resultCount');
    const popupResultCount = document.getElementById('popupResultCount');
    if (!resultCount || !popupResultCount) return;

    resultCount.innerText = `${count} Result${count !== 1 ? 's' : ''}`;
    popupResultCount.innerText = `${count} Result${count !== 1 ? 's' : ''}`;
  }

  function renderPagination(total) {
    const totalPages = Math.ceil(total / PAGE_SIZE);
    const el = document.getElementById('pagination');

    if (!el || totalPages <= 1) {
      el.innerHTML = '';
      return;
    }

    const WINDOW = 5;

    let start = Math.max(1, CURRENT_PAGE - Math.floor(WINDOW / 2));
    let end = start + WINDOW - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - WINDOW + 1);
    }

    let html = '';

    /* PREV */
    html += `
      <button class="page-btn prev ${CURRENT_PAGE === 1 ? 'disabled' : ''}" ${CURRENT_PAGE === 1 ? 'disabled' : ''}>
        Prev
      </button>
    `;

    /* FIRST + DOTS */
    if (start > 1) {
      html += `<button class="page-btn" data-page="1">1</button>`;
      if (start > 2) html += `<span class="page-dots">...</span>`;
    }

    /* WINDOW */
    for (let i = start; i <= end; i++) {
      html += `
        <button class="page-btn ${i === CURRENT_PAGE ? 'active' : ''}" data-page="${i}">
          ${i}
        </button>
      `;
    }

    /* DOTS + LAST */
    if (end < totalPages) {
      if (end < totalPages - 1) html += `<span class="page-dots">...</span>`;
      html += `<button class="page-btn" data-page="${totalPages}">${totalPages}</button>`;
    }

    /* NEXT */
    html += `
      <button class="page-btn next ${CURRENT_PAGE === totalPages ? 'disabled' : ''}" ${CURRENT_PAGE === totalPages ? 'disabled' : ''}>
        Next
      </button>
    `;

    el.innerHTML = html;

    /* PAGE CLICK */
    const eventSection = document.querySelector('.event-table');

    el.querySelectorAll('.page-btn[data-page]').forEach(btn => {
      btn.onclick = () => {
        CURRENT_PAGE = Number(btn.dataset.page);
        applyFilters(false);
        eventSection?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      };
    });

    /* PREV */
    el.querySelector('.prev')?.addEventListener('click', () => {
      if (CURRENT_PAGE > 1) {
        CURRENT_PAGE--;
        applyFilters(false);
        eventSection?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });


    /* NEXT */
    el.querySelector('.next')?.addEventListener('click', () => {
      if (CURRENT_PAGE < totalPages) {
        CURRENT_PAGE++;
        applyFilters(false);
        eventSection?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  }

  if (!IS_PAGINATION) {
    window.addEventListener('scroll', () => {

      const scrollPosition = window.innerHeight + window.scrollY;
      const threshold = document.body.offsetHeight - 200;

      if (scrollPosition >= threshold) {
        CURRENT_PAGE++;
        applyFilters(false);
      }
    });
  }

  // Reset filter

  document.querySelectorAll('.resetFilters').forEach(resetBtn => {

    resetBtn.addEventListener('click', async () => {

      /* ================= RESET STATE VARIABLES ================= */
      CURRENT_STATUS = 'all';
      // CURRENT_GENDER = 'all';
      CURRENT_REGION = 'all';
      CURRENT_COUNTRY = 'all';
      CURRENT_ENVIRONMENT = 'all';
      CURRENT_SURFACE = 'all';
      CURRENT_SEARCH = '';
      CURRENT_DATE_FROM = null;
      CURRENT_DATE_TO = null;
      CURRENT_PAGE = 1;

      document.querySelectorAll('.custom-select').forEach(select => {

        const btn = select.querySelector('.select-btn');
        const items = select.querySelectorAll('.select-item');

        items.forEach(i => i.classList.remove('active'));

        const allItem = select.querySelector('.select-item[data-value="all"]');
        if (allItem) {
          allItem.classList.add('active');
          const newText = allItem.innerText;

          // Nếu node đầu tiên là text
          if (btn.firstChild && btn.firstChild.nodeType === Node.TEXT_NODE) {
            btn.firstChild.nodeValue = newText + ' ';
          } else {
            // Nếu không có text node thì thêm vào trước SVG
            btn.insertBefore(document.createTextNode(newText + ' '), btn.firstChild);
          }
        }

        select.dataset.value = 'all';
      });

      if (typeof datePicker !== 'undefined') {
        datePicker.clear();
      }

      document.getElementById('clear-date').style.display = 'none';
      document.getElementById('env_all').checked = true;
      document.getElementById('outdoor').checked = false;
      document.getElementById('indoor').checked = false;
      document.querySelectorAll('.surface-item')
        .forEach(i => i.classList.remove('active'));

      document.querySelector('.surface-item[data-value="all"]')
        ?.classList.add('active');

      updateSurfaceButton();

      const searchInput = document.querySelector('.search-input');
      if (searchInput) searchInput.value = '';

      updateActiveFilterCount();
      updateSurfaceButton();
      await fetchInitialEvents();

    });
  });

  /* =========================================================
    RENDER TABLE ROW
  ========================================================= */
  function renderEventRow(event) {
    return `
      <tr>
        <td>
          <a href="https://app.utrsports.net/events/${event.id}" target="_blank" class="event-title">${event.name || '-'}</a>
        </td>
        <td data-start="${event.start}">
          ${formatEventDateRangeM(event.start, event.end)}
        </td>
        <td class="city">
          ${
            event.countryCode2 === 'US'
              ? formatCityOnly(event.stateName)
              : formatCity(event.city || event.stateName)
          }
        </td>
        <td>${event.campType}</td>
        <td>${event.campDuration}</td>
        <td style="display:none;text-transform: capitalize;" data-surface="${event.surface || ''}">${formatSurface(event.environment, event.surface)}</td>
        <td>
          <a href="https://app.utrsports.net/events/${event.id}" target="_blank">
            ${renderStatusBadge(event.status)}
          </a>
        </td>
      </tr>
    `;
  }

  function renderEventCard(event) {
    return `
      <div class="event-card">
        <a class="link-to-event" href="https://app.utrsports.net/events/${event.id}">
          <div class="event-card-title">
            ${event.name}
          </div>

          <div class="event-card-date">
            ${formatEventDateRangeM(event.start, event.end)}
          </div>

          <div class="event-card-row">
            <span>State:</span>
            <strong>
              ${
                event.countryCode2 === 'US'
                  ? (event.stateName || '-')
                  : (event.city || event.stateName || '-')
              }
            </strong>

          </div>
          <div class="event-card-row">
            <span>Camp duration:</span>
            <strong>${event.campDuration.toLowerCase() || '_'}</strong>
          </div>
          <div class="event-card-bottom">
            <div class="event-card-row">
              <span>Camp type:</span>
              <strong>${event.campType || '_'}</strong>
            </div>

            <div class="event-card-status">
              ${renderStatusBadge(event.status)}
            </div>
          </div>
        </a>
      </div>
    `;
  }

